"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var dayjs_1 = __importDefault(require("dayjs"));
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var insertSlotsTimeRange = function (currentSlots, newSlots) {
    var currentIndex = 0;
    var newIndex = 0;
    var newSlotsState = [];
    // Simple Double Pointer Loop Algorithm
    // Insert new slots into current slots time range
    while (!(currentIndex >= currentSlots.length && newIndex >= newSlots.length)) {
        var newSlot = newSlots[newIndex];
        var currentSlot = currentSlots[currentIndex];
        if (currentIndex < currentSlots.length && newIndex < newSlots.length) {
            var newSlotStart = dayjs_1.default(newSlot === null || newSlot === void 0 ? void 0 : newSlot.start).unix();
            var currentSlotStart = dayjs_1.default(currentSlot === null || currentSlot === void 0 ? void 0 : currentSlot.start).unix();
            // new slot is equal to current existing slot, skip it
            if (currentSlotStart === newSlotStart) {
                newSlotsState.push(currentSlot);
                // Go to the next current slot
                currentIndex += 1;
                // Go to the next new slot
                newIndex += 1;
            }
            // new slot is before existing slot, add it into result
            else if (currentSlotStart > newSlotStart) {
                newSlotsState.push(newSlot);
                // Go to the next new slot
                newIndex += 1;
            }
            // new slot is after existing slot, add current into result
            else if (currentSlotStart < newSlotStart) {
                newSlotsState.push(currentSlot);
                // Go to the next current slot
                currentIndex += 1;
            }
        }
        else if (currentIndex === currentSlots.length && newIndex < newSlots.length) {
            newSlotsState.push(newSlot);
            newIndex += 1;
        }
        else if (currentIndex < currentSlots.length && newIndex === newSlots.length) {
            newSlotsState.push(currentSlot);
            currentIndex += 1;
        }
    }
    return newSlotsState;
};
var reducers = {
    slotsByChannelId: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_SLOTS_BY_TIME_RANGE,
        onSuccess: function (draftState, action) {
            if (action.isNotModified) {
                return;
            }
            var channels = action.payload.channels;
            if (channels) {
                channels.forEach(function (channel) {
                    var _a;
                    if (ramda_1.isNil(channel)) {
                        return;
                    }
                    if ((channel === null || channel === void 0 ? void 0 : channel.__typename) === 'LinearChannel') {
                        var _b = channel, channelId = _b.id, slots = _b.slots;
                        var newSlots = slots === null || slots === void 0 ? void 0 : slots.filter(function (s) { return !ramda_1.isNil(s) && !ramda_1.isNil(s === null || s === void 0 ? void 0 : s.start) && !ramda_1.isNil(s === null || s === void 0 ? void 0 : s.end); });
                        var slotsState = draftState.data[channelId];
                        // If slots list already there
                        if (slotsState && !((_a = action.meta) === null || _a === void 0 ? void 0 : _a.isOverride)) {
                            var firstNewSlot = ramda_1.head(newSlots);
                            var lastCurrentSlot = ramda_1.last(slotsState);
                            var firstNewSlotStart = dayjs_1.default(firstNewSlot === null || firstNewSlot === void 0 ? void 0 : firstNewSlot.start).unix();
                            var lastCurrentSlotStart = dayjs_1.default(lastCurrentSlot === null || lastCurrentSlot === void 0 ? void 0 : lastCurrentSlot.start).unix();
                            // If the new slots is after all the current slots
                            if (lastCurrentSlotStart <= firstNewSlotStart) {
                                slotsState.push.apply(slotsState, (lastCurrentSlotStart === firstNewSlotStart ? newSlots.slice(1) : newSlots));
                            }
                            else {
                                var newSlotsState = insertSlotsTimeRange(slotsState, newSlots);
                                draftState.data[channelId] = newSlotsState;
                            }
                        }
                        else {
                            draftState.data[channelId] = newSlots;
                        }
                    }
                });
            }
        },
    }, {}),
    selectedSlot: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_SLOT_BY_START_TIME,
        onSuccess: function (draftState, action) {
            var _a, _b;
            draftState.data = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.linearChannel) === null || _b === void 0 ? void 0 : _b.slot;
        },
    })), (_a = {}, _a[constants_1.CLEAR_SELECTED_SLOT] = function (draftState) {
        draftState.data = null;
    }, _a)), api_1.createApiInitialState(null)),
    scheduledSlots: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_SLOTS_BY_IDS,
        onSuccess: function (draftState, action) {
            var _a;
            // TODO ideally we should not update the data if the data is not modified, but we
            // have to always override the data to trigger the RecordingUpdateManager
            if (action.isNotModified) {
                draftState.data = __spreadArrays(draftState.data);
                return;
            }
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.linearChannelSlots;
        },
    })), (_b = {}, _b[constants_1.CLEAR_SCHEDULED_SLOTS] = function (draftState) {
        draftState.data = [];
    }, _b)), api_1.createApiInitialState([])),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map